import { useDesignSystem } from 'contexts/design-system'
import FormRowEui from './formRow.eui'
import FormRowMui from './formRow.mui'
import { FormRowProps } from './types'

export type { FormRowProps } from './types'

/**
 * Shared form-field wrapper — label, help text, and blur-gated validation state.
 * Renders the EUI or MUI presentation based on the host form's design system
 * (`DesignSystemProvider`, default `'eui'`) at `EuiFormRow` prop parity.
 *
 * The row owns presentation only: *when* `isInvalid` flips stays with the
 * consumer's form state, so existing blur-gated validation timing is unchanged.
 */
export default function FormRow( props: FormRowProps ) {
	return useDesignSystem() === 'mui'
		? <FormRowMui {...props} />
		: <FormRowEui {...props} />
}
